import { Typography } from "antd";
import React from "react";
import { Link } from "react-router";
import { useMediaQuery } from "usehooks-ts";

import ChevronDownIcon from "@/assets/chevron-down.svg?react";

import { type Breadcrumb } from "./BreadcrumbsContext";

import "./index.less";

type BreadcrumbProps = {
  breadcrumbs: Breadcrumb[];
};

export const Breadcrumbs: React.FC<BreadcrumbProps> = ({ breadcrumbs }) => {
  const isMobile = useMediaQuery("(max-width: 767px)");
  const MAX_VISIBLE = 2;
  const hasHidden = isMobile && breadcrumbs.length > MAX_VISIBLE;
  const visibleCrumbs = hasHidden ? breadcrumbs.slice(-MAX_VISIBLE) : breadcrumbs;

  return (
    <div className="breadcrumbs-wrapper">
      <ChevronDownIcon className="arrow-icon" />
      <div className="breadcrumbs-container">
        {hasHidden && (
          <Typography.Text className="breadcrumb-item" type="secondary">
            {"... / "}
          </Typography.Text>
        )}
        {visibleCrumbs.map((b, i) => (
          <Typography.Text className="breadcrumb-item" type="secondary" key={i}>
            {b.to ? <Link to={b.to}>{b.label}</Link> : b.label}
            {i < visibleCrumbs.length - 1 && " / "}
          </Typography.Text>
        ))}
      </div>
    </div>
  );
};
